import React from "react";
import { Shield, Truck, RotateCcw, Award } from "lucide-react";
import { useCart } from "../contexts/CartContext";
import { PRODUCTS } from "../mock";
import { toast } from "sonner";

const MoneyBack = () => {
  const { addItem } = useCart();
  const featured = PRODUCTS[0];

  return (
    <section className="relative overflow-hidden bg-[#1A1410] text-[#FFF2EC]">
      <div className="max-w-7xl mx-auto px-4 py-16 md:py-24 grid lg:grid-cols-2 gap-10 items-center">
        <div className="relative">
          <div className="relative aspect-[4/5] rounded-3xl overflow-hidden">
            <img
              src="https://images.pexels.com/photos/6571939/pexels-photo-6571939.jpeg"
              alt="Happy customer"
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#1A1410]/70 via-transparent to-transparent" />
            <div className="absolute bottom-5 left-5 bg-[#DD4D2A] rounded-full w-24 h-24 flex flex-col items-center justify-center text-center">
              <Award className="w-5 h-5 mb-1" />
              <span className="text-[10px] font-bold uppercase leading-tight">
                30-Day
                <br />
                Guarantee
              </span>
            </div>
          </div>
        </div>

        <div>
          <div className="text-[11px] uppercase tracking-[0.35em] text-[#FFB89E] font-semibold mb-3">
            Our Promise
          </div>
          <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl font-semibold">
            Money-Back
            <br />
            <span className="italic text-[#FFB89E]">Guarantee</span>
          </h2>
          <p className="mt-5 text-[#FFF2EC]/75 max-w-lg">
            We're so confident in the quality of our products that we offer a
            satisfaction guarantee. If you're not completely satisfied, simply
            return the item within 30 days for a full refund.
          </p>

          <div className="mt-8 grid grid-cols-3 gap-4 max-w-lg">
            {[
              { icon: Shield, label: "100% Satisfaction" },
              { icon: Truck, label: "Fast Shipping" },
              { icon: RotateCcw, label: "Easy Returns" },
            ].map(({ icon: Icon, label }) => (
              <div
                key={label}
                className="flex flex-col items-center text-center gap-2 bg-white/5 rounded-2xl p-4 border border-white/10"
              >
                <Icon className="w-6 h-6 text-[#FFB89E]" />
                <span className="text-[11px] font-semibold uppercase tracking-wider">
                  {label}
                </span>
              </div>
            ))}
          </div>

          <button
            onClick={() => {
              addItem(featured);
              toast.success("Added to cart");
            }}
            className="mt-8 btn-coral inline-flex items-center justify-center px-8 py-4 rounded-full text-sm uppercase"
          >
            Add to cart
          </button>
        </div>
      </div>
    </section>
  );
};

export default MoneyBack;
